import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";

const API = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";
const inputCls = "bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

export default function PayrollFilters({ month, setMonth, filters = {}, setFilters }) {
  const { dept = "ALL", location = "ALL", q = "" } = filters;
  const [options, setOptions] = useState({ months: [], departments: [], locations: [] });
  const set = (k, v) => setFilters(f => ({ ...f, [k]: v }));

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(`${API}/api/admin/payroll/filters`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => setOptions({ months: d?.months || [], departments: d?.departments || [], locations: d?.locations || [] }))
      .catch(() => {});
  }, []);

  // Generate last 12 months as fallback
  const months = options.months.length > 0 ? options.months : (() => {
    const out = [];
    const d = new Date();
    for (let i = 0; i < 12; i++) {
      out.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
      d.setMonth(d.getMonth() - 1);
    }
    return out;
  })();

  return (
    <div className={`${card} p-5`}>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div>
          <label className={labelCls}>Pay Month</label>
          <select className={`${inputCls} w-full`} value={month} onChange={e => setMonth(e.target.value)}>
            {months.map(m => <option key={m} value={m}>{m}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Department</label>
          <select className={`${inputCls} w-full`} value={dept} onChange={e => set("dept", e.target.value)}>
            <option value="ALL">All Departments</option>
            {options.departments.map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Location</label>
          <select className={`${inputCls} w-full`} value={location} onChange={e => set("location", e.target.value)}>
            <option value="ALL">All Locations</option>
            {options.locations.map(l => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Search</label>
          <div className="flex items-center gap-2">
            <Search size={13} className="text-[#00ff90]/40 shrink-0" />
            <input className={`${inputCls} flex-1`} placeholder="Name or code…"
              value={q} onChange={e => set("q", e.target.value)} />
          </div>
        </div>
      </div>
    </div>
  );
}